var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ClipboardDirective } from './clipboard.directive';
import { CLIPBOARD_SERVICE_PROVIDER } from './clipboard.service';
import { _document, DOCUMENT } from './document.service';
import { WindowSrv } from './window.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
export { ClipboardDirective } from './clipboard.directive';
export { ClipboardService, CLIPBOARD_SERVICE_PROVIDER_FACTORY, CLIPBOARD_SERVICE_PROVIDER } from './clipboard.service';
var ClipboardModule = (function () {
    function ClipboardModule() {
    }
    return ClipboardModule;
}());
ClipboardModule = __decorate([
    NgModule({
        declarations: [ClipboardDirective],
        exports: [ClipboardDirective],
        imports: [CommonModule],
        providers: [
            { provide: DOCUMENT, useFactory: _document },
            WindowSrv,
            CLIPBOARD_SERVICE_PROVIDER
        ]
    })
], ClipboardModule);
export { ClipboardModule };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-clipboard/dist/src/index.js
// module id = 1084
// module chunks = 4